import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/scss/bootstrap.scss'
import 'animate.css'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import './assets/scss/style.scss'
import 'bootstrap'
import CoolLightBox from 'vue-cool-lightbox'
import VueScrollActive from 'vue-scrollactive'
import AOS from 'aos'
import 'aos/dist/aos.css'
import VueTypedJs from 'vue-typed-js'
import Vuex from 'vuex'
import store from '../src/store/index'
import { createPinia } from 'pinia' // นำเข้า createPinia
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueI18n from 'vue-i18n'
import VueCarousel from 'vue-carousel'

Vue.config.productionTip = false
Vue.use(CoolLightBox)
Vue.use(VueScrollActive)
Vue.use(VueTypedJs)
Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(createPinia())
Vue.use(VueCarousel)

import i18n from '../i18n/i18n'

new Vue({
  router,
  store,
  i18n,
  created() {
    AOS.init({
      duration: 800,
      once: true
    })
  },
  render: (h) => h(App)
}).$mount('#app')
